import { render, staticRenderFns } from "./community-list.vue?vue&type=template&id=aac09718&scoped=true"
import script from "./community-list.vue?vue&type=script&lang=js"
export * from "./community-list.vue?vue&type=script&lang=js"
import style0 from "./community-list.vue?vue&type=style&index=0&id=aac09718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac09718",
  null
  
)

export default component.exports